export default __webpack_public_path__ + "static/media/mindmap.a5e5a86c.svg";